import { useRef, useEffect } from "react";
import {
  EggFried, Beef, Pizza, Wheat, Salad, CupSoda, CakeSlice, LayoutGrid,
} from "lucide-react";
import { categories } from "@/data/menu";
import { useLang } from "@/context/LanguageContext";
import { localize } from "@/lib/format";

const ICONS = { EggFried, Beef, Pizza, Wheat, Salad, CupSoda, CakeSlice };

export function CategoryNav({ active, onSelect, showAll = true }) {
  const { lang, t } = useLang();
  const scrollRef = useRef(null);
  const activeRef = useRef(null);

  useEffect(() => {
    if (activeRef.current) {
      activeRef.current.scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
    }
  }, [active]);

  const items = showAll
    ? [{ id: "all", slug: "all", name: t("allCategories"), icon: "LayoutGrid" }, ...categories]
    : categories;

  return (
    <div ref={scrollRef} className="no-scrollbar flex gap-2 overflow-x-auto px-4 py-1" data-testid="category-nav">
      {items.map((cat) => {
        const Icon = cat.icon === "LayoutGrid" ? LayoutGrid : ICONS[cat.icon] || LayoutGrid;
        const isActive = active === cat.id;
        return (
          <button
            key={cat.id}
            ref={isActive ? activeRef : null}
            onClick={() => onSelect(cat.id)}
            className={`flex shrink-0 items-center gap-2 rounded-full border px-4 py-2.5 text-sm font-semibold transition-colors active:scale-95 ${
              isActive
                ? "border-transparent brand-gradient text-white shadow-soft"
                : "border-border bg-card text-foreground hover:border-primary/40"
            }`}
            data-testid={`category-chip-${cat.slug}`}
          >
            <Icon className="h-4 w-4" />
            {localize(cat.name, lang)}
          </button>
        );
      })}
    </div>
  );
}
